import { useSearchParams } from "react-router-dom";

const useQuery = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  // Convert searchParams to a plain object
  const queryParams = Object.fromEntries(searchParams.entries());

  // Function to set query parameters
  const setQueryParams = (newParams: Record<string, any>) => {
    const updatedParams = new URLSearchParams(searchParams.toString());

    Object.entries(newParams).forEach(([key, value]) => {
      if (value === undefined || value === null || value === "") {
        updatedParams.delete(key);
      } else {
        updatedParams.set(key, value);
      }
    });

    setSearchParams(updatedParams);
  };

  return { queryParams, setQueryParams };
};

export default useQuery;
